
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 30 30","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero","fill":"#515358"}},[_c('path',{attrs:{"d":"M.267 14.474h14.384V.09H.267v14.384zm4.697-8.947l.58-.595 2.145 2.145L9.83 4.932l.584.583-2.146 2.141 2.146 2.145-.584.58L7.69 8.24l-2.145 2.14-.58-.579 2.141-2.145-2.14-2.129zM.267 29.68h14.384V15.295H.267v14.383zm3.978-7.985h6.884v.821H4.245v-.821zM15.473 14.474h14.383V.09H15.473v14.384zm6.957-3.962a.411.411 0 110-.822.411.411 0 010 .822zm0-5.687a.411.411 0 110 .822.411.411 0 010-.822zm-3.44 2.433h6.9v.821h-6.9v-.821zM15.473 29.68h14.383V15.295H15.473v14.383zm3.517-7.985h3.03v-3.033h.821v3.033h3.05v.821h-3.05v3.03h-.822v-3.03H18.99v-.821z"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/toolbars/designerToolbar/calculation.svg